var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.317 2.242 1.442 1.441-.009.009a1.041 1.041 0 0 1 0 1.475l-5.625 5.625a.915.915 0 0 1-.466.25l-1.834.366c-.075.017-.142.017-.208.017-.275 0-.534-.108-.734-.308-.241-.25-.35-.6-.283-.942l.367-1.842a.914.914 0 0 1 .25-.466l5.625-5.625a1.041 1.041 0 0 1 1.475 0Zm-6.434 7.866 1.434-.283-.008-.008 4.025-4.025-1.142-1.142-4.025 4.025-.284 1.433Zm5.2-6.333 1.142 1.142.5-.5-1.142-1.142-.5.5Zm.959 5.133a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v7.342c0 .575-.467 1.042-1.042 1.042H3.75a1.042 1.042 0 0 1-1.042-1.042V3.75c0-.575.467-1.042 1.042-1.042h7.367a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625H3.958v12.084h12.084V8.908Z",
    fill: "current"
  })));
};
export default SvgEdit;